import { DefaultTheme } from '@mui/styles'

export const SIDEBAR_PADDING = 36
export const SIDEBAR_BUTTON_HEIGHT = 60
export const INDICATOR_HEIGHT = 25
export const SIDEBAR_ICON_SIZE = 30
export const SIDEBAR_ICON_SPACING = 15

export const DRAWER_WIDTH = 290
export const DRAWER_WIDTH_CLOSED = SIDEBAR_PADDING * 2 + SIDEBAR_ICON_SIZE

export const drawerTransition = (theme: DefaultTheme, property: string | string[]) => (
  theme.transitions.create(property, {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen,
  })
)
